var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(_vm.val === 2)?_c('span',[_vm._v("长期")]):(_vm.val === 1)?_c('span',[_vm._v("短期")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }